import { Col, SelectField } from '@/components';
import { COL_MIN_WIDTH } from '@/features/search/_utils/projects-search';
import { KsAnalysisAxisLabelModifier, ksAnalysisAxisEnum } from '@/utils/enum';
import { type FC, memo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { KsAnalysisSearchFormType } from '../../_models/ks-analysis-search';

// `total` は「合計のみ（軸なし）」を表す URL センチネルなので選択肢には出さない（RS-4424）。
const options = ksAnalysisAxisEnum.options.flatMap((value) => {
  if (value === 'total') {
    return [];
  }
  return [
    {
      value,
      label: KsAnalysisAxisLabelModifier[value],
    },
  ];
});

export const KsAnalysisAxisColField: FC = memo(() => {
  const { t } = useTranslation();

  const {
    control,
    formState: { errors },
  } = useFormContext<KsAnalysisSearchFormType>();

  return (
    <Col span={4} style={{ minWidth: COL_MIN_WIDTH.basic }}>
      <SelectField
        name="analysisAxis"
        label={t('axis-of-analysis')}
        control={control}
        options={options}
        errors={errors}
      />
    </Col>
  );
});
